import { apiGet, apiPut } from '../helpers/ApiHelper';
import Auth from 'j-toker';
import { browserHistory } from 'react-router';

// Landlord Reference Verification
function displayLandlordReferenceVerification(response) {
  return {
    type: 'DISPLAY_LANDLORD_REFERENCE_VERIFICATION',
    landlord_reference_verification: response,
  };
}

function displaySuccessfulVerificationMessage() {
  return {
    type: 'DISPLAY_SUCCESSFUL_VERIFICATION_MESSAGE',
  };
}

export function displayLoader(shouldDisplay) {
  return {
    type: 'DISPLAY_LOADER',
    display: shouldDisplay,
  };
}

export function getLandlordReferenceVerification(uuid) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/landlord_references/verification/' + uuid)
        .done(response => {
          if (response.data.landlord_reference.verified) {
            dispatch(displayLoader(false));
            dispatch(displaySuccessfulVerificationMessage());
          } else {
            dispatch(displayLandlordReferenceVerification(response.data));
          }
        })
        .catch(error => {
          dispatch(displayLoader(false));
          console.error('request failed', error);
          browserHistory.push('/dashboard');
        }),
    });
  };
}

export function putLandlordReferenceVerification(uuid, data) {
  let data_clone = JSON.parse(JSON.stringify(data));
  data_clone.had_late_payments = data.had_late_payments.toLowerCase() === 'yes';
  data_clone.sent_notices = data.sent_notices.toLowerCase() === 'yes';
  data_clone.rent_amount_confirmed = data.rent_amount_confirmed.toLowerCase() === 'yes';
  data_clone.lived_for_confirmed = data.lived_for_confirmed.toLowerCase() === 'yes';
  return dispatch => {
    return dispatch({
      payload: apiPut(
        Auth.getApiUrl() + '/leads/landlord_references/verification/' + uuid,
        data_clone
      )
        .done(response => {
          dispatch(displaySuccessfulVerificationMessage());
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}

// Personal Reference verification
function displayPersonalReferenceVerification(response) {
  return {
    type: 'DISPLAY_PERSONAL_REFERENCE_VERIFICATION',
    personal_reference_verification: response,
  };
}

export function getPersonalReferenceVerification(uuid) {
  return dispatch => {
    return dispatch({
      payload: apiGet(Auth.getApiUrl() + '/leads/personal_references/verification/' + uuid)
        .done(response => {
          if (response.data.personal_reference.verified) {
            dispatch(displayLoader(false));
            dispatch(displaySuccessfulVerificationMessage());
          } else {
            dispatch(displayPersonalReferenceVerification(response.data));
          }
        })
        .catch(error => {
          dispatch(displayLoader(false));
          console.error('request failed', error);
          browserHistory.push('/dashboard');
        }),
    });
  };
}

export function putPersonalReferenceVerification(uuid, data) {
  let data_clone = JSON.parse(JSON.stringify(data));
  data_clone.relationship_confirmed = data.relationship_confirmed.toLowerCase() === 'yes';
  data_clone.duration_confirmed = data.duration_confirmed.toLowerCase() === 'yes';
  return dispatch => {
    return dispatch({
      payload: apiPut(
        Auth.getApiUrl() + '/leads/personal_references/verification/' + uuid,
        data_clone
      )
        .done(response => {
          dispatch(displaySuccessfulVerificationMessage());
        })
        .catch(error => {
          console.error('request failed', error);
        }),
    });
  };
}
